import { supabase } from '../lib/supabaseClient';
import { AccountError, accountError, readProfile, type ProfilePatch, type UserProfile } from '../models/account';

export const profileService = {
    async get(userId: string): Promise<UserProfile | null> {
        const { data, error } = await supabase.from('profiles').select('*').eq('id', userId).maybeSingle();
        if (error) throw new AccountError('unavailable', 'Profile details could not be loaded. Please retry.');
        return data ? readProfile(data, userId) : null;
    },
    async update(userId: string, revision: number, patch: ProfilePatch): Promise<UserProfile> {
        const { data, error } = await supabase.rpc('update_my_profile', { p_expected_revision: revision, p_patch: patch });
        if (error) throw accountError(error);
        return readProfile(data, userId);
    },
    async ensure(userId: string): Promise<UserProfile> {
        const { data, error } = await supabase.rpc('ensure_my_profile');
        if (error) throw accountError(error);
        return readProfile(data, userId);
    },
    async getStats(): Promise<number> {
        const { data, error } = await supabase.rpc('get_my_account_stats');
        if (error || !Number.isInteger(data?.active_projects) || data.active_projects < 0) {
            throw new AccountError('unavailable', 'Active projects could not be counted.');
        }
        return data.active_projects;
    },
};
